var _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconUserActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 31,
    viewBox: "0 0 30 31",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 5.06139C12.9289 5.06139 11.25 6.76094 11.25 8.85743C11.25 10.9539 12.9289 12.6535 15 12.6535C17.0711 12.6535 18.75 10.9539 18.75 8.85743C18.75 6.76094 17.0711 5.06139 15 5.06139ZM8.75 8.85743C8.75 5.36327 11.5482 2.53069 15 2.53069C18.4518 2.53069 21.25 5.36327 21.25 8.85743C21.25 12.3516 18.4518 15.1842 15 15.1842C11.5482 15.1842 8.75 12.3516 8.75 8.85743Z",
    fill: "url(#paint0_linear_0_709)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 25.307C11.3389 25.307 9.16827 24.1857 7.91921 22.7393C7.53862 22.2985 7.43944 21.9112 7.45094 21.5933C7.46321 21.2542 7.60803 20.8617 7.93401 20.4596C8.6036 19.6336 9.87664 18.9802 11.25 18.9802H18.75C20.1233 18.9802 21.3964 19.6336 22.066 20.4596C22.3919 20.8617 22.5368 21.2542 22.549 21.5933C22.5605 21.9112 22.4614 22.2985 22.0808 22.7393C20.8317 24.1857 18.6611 25.307 15 25.307ZM6.03697 24.4048C7.87767 26.5364 10.8166 27.8376 15 27.8376C19.1834 27.8376 22.1223 26.5364 23.963 24.4048C24.7183 23.5302 25.0845 22.5277 25.0474 21.5007C25.011 20.495 24.593 19.5876 23.9986 18.8542C22.8272 17.4093 20.8284 16.4495 18.75 16.4495H11.25C9.17156 16.4495 7.17278 17.4093 6.00142 18.8542C5.40693 19.5876 4.98901 20.495 4.95261 21.5007C4.91545 22.5277 5.28168 23.5302 6.03697 24.4048Z",
    fill: "url(#paint1_linear_0_709)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_0_709",
    x1: 20.1181,
    y1: 15.1842,
    x2: 8.89668,
    y2: 13.974,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F0BA47"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.677095,
    stopColor: "#F3D25C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_0_709",
    x1: 5.28811,
    y1: 27.8376,
    x2: 25.4603,
    y2: 27.0574,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#01A0AA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#076B9E"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconUserActive);
export default __webpack_public_path__ + "static/media/icon_user_active.566244bdf85ce6f6ff094f56a1a16231.svg";
export { ForwardRef as ReactComponent };